export default __webpack_public_path__ + "static/lframe-calculator-e3389af1d91663e44707616334eaea21.png";